import { RESET_CART, EMPTY_CART, RESTORE_CART, SET_DISPENSARIES, SET_FEE_STRUCTURE, SET_BULK_DISCOUNT, SET_DISPENSARY_PRODUCTS, SET_DISPENSARY, SET_DELIVERY_ADDRESS, SET_ANON_USER_ZIP_CODE, ADD_TO_CART, REMOVE_ITEM, SUB_QUANTITY, ADD_QUANTITY, SET_DELIVERY_WINDOW, SET_PICKUP_TIME_SLOT, SET_IS_PICKUP, SET_ORDER_HISTORY } from './action-types/cart-actions'

// reset cart ( e.g on log out )
export const resetCart = () => {
  return {
    type: RESET_CART
  }
}

// reset cart ( e.g on place order --- does not clear current dispensary )
export const emptyCart = () => {
  return {
    type: EMPTY_CART
  }
}

// restore cart from previous session on session start
export const restoreCart = (dispensaryId, items, orderType) => {
  return {
    type: RESTORE_CART,
    dispensaryId,
    items,
    orderType
  }
}

// set dispensary action
// will add Id later
export const setDispensary = (dispensaryId) => {
  return {
    type: SET_DISPENSARY,
    dispensaryId
  }
}

// set data for ALL dispensaries
export const setDispensaries = (dispensaries) => {
  return {
    type: SET_DISPENSARIES,
    dispensaries
  }
}

// set the values (fees/taxes) used in the total price calc
export const setFeeStructure = (cannabis_tax_percent, sales_tax_percent, delivery_fee_cents, delivery_service_fee_percent, pickup_fee_cents, pickup_service_fee_percent, in_store_payment_fee_percent) => {
  return {
    type: SET_FEE_STRUCTURE,
    cannabis_tax_percent, /* new */
    sales_tax_percent,    /* new */
    delivery_fee_cents,
    delivery_service_fee_percent,
    pickup_fee_cents,
    pickup_service_fee_percent,
    in_store_payment_fee_percent
  }
}

// set the bulk discount for trhe current order
export const setBulkDiscount = (discount_cents, discount_label) => {
  return {
    type: SET_BULK_DISCOUNT,
    discount_cents,
    discount_label
  }
}

export const setDispensaryProducts = (dispensaryId, products) => {
  return {
    type: SET_DISPENSARY_PRODUCTS,
    dispensaryId, 
    products
  }  
}

// set delivery address action
export const setDeliveryAddress = (delivery_address, tel_number, user_name) => {
  return {
    type: SET_DELIVERY_ADDRESS,
    delivery_address,
    tel_number,
    user_name
  }
}

// set anonymous user zip code
export const setAnonymousUserZipCode = (zip_code) => {
  return {
    type: SET_ANON_USER_ZIP_CODE,
    zip_code
  }
}

// add cart action - optional productObj is used for non-dispensary-page add-to-cart
export const addToCart= (Id, productObj, quantity)=>{
  return {
    type: ADD_TO_CART,
    Id,
    productObj,
    quantity
  }
}
// remove item action
export const removeItem=(Id)=>{
  return {
    type: REMOVE_ITEM,
    Id
  }
}
// subtract quantity action
export const subtractQuantity=(Id)=>{
  return {
    type: SUB_QUANTITY,
    Id
  }
}
// add quantity action
export const addQuantity=(Id)=>{
  return {
    type: ADD_QUANTITY,
    Id
  }
}

// set delivery window
export const setDeliveryWindow=(delivery_window)=>{
  return {
    type: SET_DELIVERY_WINDOW,
    delivery_window
  }
}

// set pickup time slot
export const setPickupTimeSlot=(pickup_time_slot)=>{
  return {
    type: SET_PICKUP_TIME_SLOT,
    pickup_time_slot
  }
}

// set pickup flag
export const setIsPickup=(isPickup)=>{
  return {
    type: SET_IS_PICKUP,
    isPickup
  }
}

// set order history
export const setOrderHistory=(orders)=>{
  return {
    type: SET_ORDER_HISTORY,
    orders
  }
}
